import { ENDPOINT_NAMES, endpoints } from '../../config/endpoints';
import ASSESSMENT_STATUSES from '../../constants/assessment-status';
import DEFAULT_REFETCH_INTERVAL from '../../constants/default-refetch-interval';
import { useData } from '@llt-frontend/react-fetch';

// Exports
// -------

export default function useNextAssessment({
  refetchInterval = DEFAULT_REFETCH_INTERVAL,
  studentId,
}) {
  const endpoint = endpoints.get(ENDPOINT_NAMES.dayOrchestratorAssessments, { studentId });
  return useData(endpoint.path, {
    queryKey: endpoint.key,
    queryOptions: {
      refetchInterval,
      select(data) {
        const assessment = data?.filter(
          (assessment) =>
            typeof assessment.state !== 'undefined' &&
            assessment.state !== ASSESSMENT_STATUSES.finished
        )?.[0];

        if (!assessment) {
          return;
        }

        return {
          assessmentId: assessment.assessment_id,
          subjectName: assessment.subject_name,
          iteration: assessment.iteration,
        };
      },
    },
    request: {
      method: 'PUT',
    },
  });
}
